import React from 'react';
import styled from 'styled-components';
import { IWrapper } from './Button';
import Icon from './Icon';

const LinkTo = styled.a`
    cursor: pointer;
    text-decoration-thickness: 0.05em;
    display: flex;
    gap: 1em;
    
    &:link {
        color: ${({ theme }) => theme.link};
    }
    &:visited {
        color: ${({ theme }) => theme.link};
    }
    &:hover {
        color: ${({ theme }) => theme.highlight}
    }
    &:active {
        color: ${({ theme }) => theme.active}
    }
`

const HamLink = ({ icon, children, ...props }) => <LinkTo {...props}>{icon ? <IWrapper><Icon icon={icon} /></IWrapper> : null}<span>{children}</span></LinkTo>

export default HamLink;